const content = {
    target_order_detail: {
        en: {
            summary_no_video_html: `
            <h2>Before you start</h2> 
            <p>It’s important you complete each step, or we won’t be able to process your payment! Our
              instructions are easy to follow.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
                <p>Open the <b>Target</b> shopping app and login before starting the <b>screen record</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                <p>Tap on <b>My Target</b> (bottom right) and then tap <b>Purchase History</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `
                <p>Tap your most recent <b>Online Order</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `
                <p><b>Scroll to the bottom</b> of the order details.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `
                <p> Repeat this process for <b>every order</b> going back <b>to the last 10 orders</b> - if you have less than 10 orders, show the maximum number you can.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `
                <p>Stop the recording once you have shown <b>the last 10 orders</b> of order history.</p>`
                },
            ],
            after_steps_html: `<h2 class="hint-title" style="margin-top:1.5rem;">Helpful hint</h2>
            <p>It is recommended that you upload your video when connected to wifi.</p>`,
        }
    }
};

export const targetDataTypes = {
    target_order_detail: {
        data_type: 'target_order_detail',
        data_type_description: 'Target Orders',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/target/logo.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.target_order_detail,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.target_order_detail,
        },   
    },
};